import { OrganizationType } from '@/types/gql.generated';
import type { IconName } from '@/ui/Icon/Icon';

// Shared-org visual identity: FAMILY reads as a household, BUSINESS as a
// company. PERSONAL contexts never surface a type icon.
export const getOrgTypeIcon = (type: OrganizationType): IconName =>
  type === OrganizationType.Family ? 'House' : 'Building2';

// Org names are free text and people don't reliably capitalize them, so copy
// that opens with one ("smith family projects") lifts the leading character.
// Only that character changes — the rest is left alone so deliberate casing
// survives ("NASA", "iOS Team", "d'Angelo Family").
export const capitalizeOrgName = (name: string) =>
  name.charAt(0).toUpperCase() + name.slice(1);
